<div class="myvf-sticky-feed-action">
  <ng-content></ng-content>
</div>
